import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {userService} from "../../services/user.service";

const initialState = {
    user: {},
    status: '',
    error: {}
}

const getById = createAsyncThunk(
    'userDetailsSlice/getById',
    async ({id},) => {
        try {
            const {data} = await userService.getById(id);

            return data;
        } catch (error) {
            throw error;
        }
    }
);

const userDetailsSlice = createSlice({
    name: 'userDetailsSlice',
    initialState,
    reducers: {
        setError: (state, action) => {
            state.error = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        }
    },
    extraReducers: (builder) => builder
        .addCase(getById.fulfilled, (state, action) => {
            const {password, ...userInfo} = action.payload;
            state.user = userInfo;

            state.status = 'success';
        })
        .addCase(getById.pending, (state, action) => {
            state.status = 'loading';
        })
});

const {actions, reducer: userDetailsReducer} = userDetailsSlice;

const userDetailsActions = {
    ...actions,
    getById,
}

export {
    userDetailsActions,
    userDetailsReducer,
}
